const getStyles = () => {
  return {
    lableCss: {
      color: '#232323b2',
      marginBottom: '4px',
      textAlign: 'left'
    },
    textDanger: {
      color: '#d32f2f',
      fontSize: '0.75rem'
    }
  };
};

export default getStyles;
